import * as actionTypes from '../constants/actionTypes'

export const toggleHistory = () => ({
  type: actionTypes.TOGGLE_HISTORY,
})



// WEBPACK FOOTER //
// ./src/actions/uiActions.js